// Citation types compatible with CHIRP service

const _unhandledEnumCase = Symbol('unhandled-enum-case');
export const CrmCitationTypename = 'com.hubspot.copilot.tools.results.citations.CrmCitation';
export const DashworksCitationTypename = 'com.hubspot.copilot.tools.results.citations.DashworksCitation';
export const LegacyCitationTypename = 'com.hubspot.copilot.tools.results.citations.LegacyCitation';
export const WebPageCitationTypename = 'com.hubspot.copilot.tools.results.citations.WebPageCitation';
export const MemoryCitationTypename = 'com.hubspot.copilot.tools.results.citations.MemoryCitation';
import { ChatMessageCitationTypename } from '../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
export { ChatMessageCitationTypename };